
const membershipVariantId = 43564373213241;
const shippingProtectionId = 43638369517625;

let scAddingMembershipInProgress = false;

 // Disable shipping protection for selected products 

function scDisableShippingProtection (cart) {
  /* Exclude products from tententel vendor, VIP membership and shipping protection */
  let nonShippingRequired = cart.items.every(item => {if(item.vendor == "tententel" || item.product_id == 7631437889593 || item.product_id == 7657540550713 ) return true});
  let shippingCheckbox = document.querySelector('#slidecarthq .shipping-protection input');
  let shippingProtectionContainer = document.querySelector('#slidecarthq .footer-row.shipping-protection');
  if (nonShippingRequired && shippingProtectionContainer) {
      if (shippingCheckbox.checked) {
        console.log('disabling shipping protection...');
        shippingCheckbox.click();
        SLIDECART_STATE().removeFromCart(shippingProtectionId);
      }
      shippingProtectionContainer.style.display = "none";      
  } else if (shippingProtectionContainer) {
    console.log('enabling shipping protection...');
    shippingProtectionContainer.style.display = "block";
  }
}

function isMembershipItem (item) {
  // Define the logic to determine if an item is a membership item
  return item.id == membershipVariantId;
}

function updateCart (cart) {
  // automatically add or remove 'VIP Insiders Club' product
  const sellingPlanId = 5725421625;

  // Get the current cart state
  // const cart = window.SLIDECART_STATE().cart;

  // Check for membership items in the cart
  const membershipItems = cart.items.filter(item => isMembershipItem(item));
  const otherItems = cart.items.filter(item => {
    if ([membershipVariantId, shippingProtectionId].includes(item.id)) {
      return false;
    } else if (item.vendor === 'tententel') {
      return false;
    }
    return true;
  });

  const isMember = ["members-only_0", "vip-membership"].some(membershipTag => (window.customerTags || []).includes(membershipTag));

  const updates = {};

  if (membershipItems.length > 0) {
    console.log("Other Items: ", otherItems.length);
    if (isMember) {
      console.log('removing membership product...');
      membershipItems.forEach(item => updates[item.id] = 0);
      updateCartItems(updates);
    } else {
      membershipItems.forEach(item => {
        if (item.quantity > 1) updates[item.id] = 1;
      });
      if (Object.keys(updates).length > 0) {
        updateCartItems(updates);
      }
    }
  } else if (membershipItems.length === 0 && !isMember && otherItems.length > 0) {
    console.log('adding membership product...', cart);
    const item = cart.items.find(item => item.id === membershipVariantId);
    if (!item) {
      addItem(membershipVariantId, 1, sellingPlanId);
      scAddingMembershipInProgress = true;
    }
  }
}

function addItem (variantId, quantity, sellingPlanId) {
  if (!scAddingMembershipInProgress) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity, selling_plan: sellingPlanId })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Membership added to cart:', data);
      console.log('calling slide cart update...');
      setTimeout(() => {
        scAddingMembershipInProgress = false;
      }, 1000);
      window.SLIDECART_UPDATE();
    });
  }
}

function updateCartItems (updates) {
  console.log('updateCartItems called...');
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated:', data);
    console.log('calling slide cart update...');
    window.SLIDECART_UPDATE();
  });
}

function addMembershipContent (cart) {
  const item = cart.items.find(({ id }) => id === membershipVariantId);
  const memberItem = document.querySelector(`#slidecarthq .item[data-line-item-id="${item?.id}"] .main-bottom`);
  
  if (memberItem && !memberItem.parentElement.querySelector('.main-content')) {
    memberItem.insertAdjacentHTML('afterend', `
      <div class="main-content">
        Try our VIP site free for 14 days. Get up to 70% off, $100 monthly store credit, 
        35 Tesla entries, and a warranty on lost, or broken items. Skip or cancel anytime.
      </div>
    `);
  }
}

function scAddAtcListeners () {
  document.addEventListener('click', e => {
    if (e.target.matches('ul.addtc-dropdown li, ul.addtc-dropdown li *, form.product-single__form button.add-to-cart, form.product-single__form button.add-to-cart *')) {
      setTimeout(window.SLIDECART_OPEN, 800);
    }
  }, true);
}

// Use the SLIDECART_LOADED callback instead of DOMContentLoaded
window.SLIDECART_LOADED = cart => {
  scAddAtcListeners();
  // updateCart();
  console.log('Cart loaded:', cart);
  scDisableShippingProtection(cart);
}

// window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
  // Fires whenever an item is removed from cart
  // updateCart();
//}

// Listen for updates to the slide cart
window.SLIDECART_UPDATED = cart => {
  console.log('Slide cart was updated: ', cart);
  /*setTimeout(() => {
    // adding delay so that shipping protection and membership product won't get added at the same time
    // this fixes the issue where the shipping protection product / amount is not added to the cart
    /updateCart(cart);
  }, 1000);*/
  // addMembershipContent(cart);
  scDisableShippingProtection(cart);
}